import { LinkReturnToMain } from 'Components';
import { SuppliersContext } from 'Context/SuppliersContext';
import { useContext, useEffect } from 'react';
import { Title } from './Title';
import { Categories } from './Categories';

export const Lobby = () => {
  const { setStepIndex } = useContext(SuppliersContext);

  useEffect(() => {
    setStepIndex(1);
  }, [setStepIndex]);

  return (
    <>
      <LinkReturnToMain />
      <Title />
      <Categories />
    </>
  );
};
